export { BentoCard, type BentoCardProps } from './bento-card';

// Re-export shadcn card sub-components for use with BentoCard
export {
  CardHeader as BentoCardHeader,
  CardContent as BentoCardContent,
  CardFooter as BentoCardFooter,
  CardTitle as BentoCardTitle,
  CardDescription as BentoCardDescription,
  CardAction as BentoCardAction,
} from '@/app/_components/ui/card';
